import { Box } from '@mui/material'
import { useEffect, useRef, useState } from 'react';
import { Content } from './Content';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { Loader } from '../publication/view/Loader';
import { NoData } from '../publication/view/NoData';
import { ActionButton } from './ActionButton';
import { SignupForm } from './SignUpForm';
import { Comment } from './Comment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const UBR = () => {
    const [itemData, setitemData] = useState(null)
    const [isLoader, setisLoader] = useState(false)
    const [showComment, setShowComment] = useState(false)

    const history = useHistory();
    const signupRef = useRef(null);
    const location = window.location.pathname
    
    let path = location.split('/')[4]
    const decodePath = atob(path)    
    
    const getData = async () => {
        setisLoader(true)
        const data = await rqx.get(`<<tool>>/${env()}/psl/post/publicationUBR`, { id: decodePath });
        setitemData({...data.publication[0], ...data.counts});                        
        setisLoader(false)
    };

    useEffect(() => {
        getData()
        // eslint-disable-next-line
    },[])

    const actionHandler = () => {
        signupRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Box height="100%" width="100%" bgcolor="#FFFFFF" display="flex" justifyContent="center" overflow="auto" className="publication-scrollbar">
            <Box maxWidth="750px" width="100%" >
                <Box display="flex" justifyContent="center" py="24px">
                    <Box sx={{ textTransform: "capitalize", fontWeight: "bold" }}>{location.split("/")[3]}</Box>
                </Box>
                {
                    isLoader ? 
                        <Loader/>
                    :
                        (
                            itemData !== null?
                                <>
                                    <Content itemData={itemData} />                                    
                                    <ActionButton itemData={itemData} actionHandler={actionHandler} setShowComment={setShowComment}/>
                                    <SignupForm signupRef={signupRef}/>
                                    <Box height="300px" />
                                </>
                            :
                                <NoData location={location} history={history}/>
                        )
                }
            </Box>
            {showComment &&
                <Comment decodePath={decodePath} showComment={showComment} setShowComment={setShowComment}/>
            }
        </Box>
    )
}

export default UBR
